import React from "react"
import {Deal} from "@irati/types"
import {Hr} from "@irati/ui/src/Layout"
import {H4} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import ExpandingList from "@irati/ui/src/ExpandingList"

interface Props {
  id?: string
  deal: Deal
}

const DealFAQ: React.FC<Props> = ({deal}) => {
  if (!Array.isArray(deal.frequentlyAskedQuestions) || deal.frequentlyAskedQuestions.length === 0) return null

  const faqListItems = deal.frequentlyAskedQuestions.map((faq) => {
    return {title: faq.question, description: faq.answer}
  })

  return (
    <>
      <Hr />
      <H4 marginBottom={3}>
        <FormattedMessage id="perks.components.dealInfoBlock.faq.header" />
      </H4>
      <ExpandingList items={faqListItems} />
    </>
  )
}

export default DealFAQ
